import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {api} from "../../app/api";
import {addLike, addShareCount} from "../News/newsSlice";
import currentProposal from "../CurrentProposal/CurrentProposal";


export const fetchProposal = createAsyncThunk(
    'payments/fetchProposal',
    async () => {
        api.defaults.headers = {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
        const response = await api.get('/actions')
        return response.data
    }
)
export const fetchCurrentProposal = createAsyncThunk(
    'proposal/fetchCurrentProposal',
    async (id) => {
        const response = await api.get(`/actions/${id}`)
        return response.data
    }
)

export const addActionLike = createAsyncThunk(
    'news/addLike',
    async (id) => {
        const response = await api.patch(`/actions/${id}/like`)
        return response.data
    }
)

export const addActionShareCount = createAsyncThunk(
    'news/addShareCount',
    async (id) => {
        const response = await api.post(`/actions/${id}/share`)
        return response.data
    }
)

const proposalSlice = createSlice({
    name: 'proposal',
    initialState: {
        isLoaded: false,
        proposal: [],
        likes: '',
        currentProposal: {},
        error: {
            failed: false,
            message: null,
        }
    },
    extraReducers: {
        [fetchProposal.pending]: (state) => {
            state.isLoaded = false;
            state.error.failed = false;
            state.error.message = null;
        },
        [fetchProposal.fulfilled]: (state, action) => {
            state.proposal = action.payload
            state.isLoaded = true;
            state.likes = action.payload.likes_count
        },
        [fetchProposal.rejected]: (state, action) => {
            state.isLoaded = false;
            state.error.message = action.payload;
            state.error.failed = true;
        },
        [fetchCurrentProposal.pending]: (state) => {
            state.isLoaded = false;
            state.error.failed = false;
            state.error.message = null;
        },
        [fetchCurrentProposal.fulfilled]: (state, action) => {
            state.currentProposal = action.payload
            state.isLoaded = true;
        },
        [fetchCurrentProposal.rejected]: (state, action) => {
            state.isLoaded = false;
            state.error.message = action.payload;
            state.error.failed = true;
        },
        [addActionLike.fulfilled]: (state, action) => {
            state.currentProposal = action.payload
            state.likes = action.payload.likes_count
        },
        [addActionShareCount.fulfilled]: (state, action) => {
            state.currentProposal = action.payload
        }
    }
})
export default proposalSlice.reducer